import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { Card } from './Card';

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description?: string;
  action?: ReactNode;
}

// İkon kuralı: bare, çerçeve/kutu yok (bkz. SINIF_PLATFORM_PLAN.md §2.3).
export function EmptyState({ icon: Icon, title, description, action }: EmptyStateProps) {
  return (
    <Card className="p-16 flex flex-col items-center justify-center text-center border-dashed border-2">
      <Icon size={40} className="text-text-muted mb-4" />
      <h3 className="text-lg font-bold text-text-primary mb-2">{title}</h3>
      {description && <p className="text-text-secondary max-w-md mx-auto mb-6 text-sm">{description}</p>}
      {action}
    </Card>
  );
}
